module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_green_hover.1b579ed2.svg";